import { Component, Input, OnInit, ViewChild, Output, EventEmitter, inject, HostListener, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { SelectItem, TreeNode } from "primeng/api";
import { Discrepancy } from "../../models/discrepancy";
import { VarianceService } from "src/app/services/variance.service";
import { CommentModalComponent } from "../comment-modal/comment-modal.component";
import { getLocalTimeOffset } from 'src/app/shared/timezone.util';
import { ResolutionCodingModalComponent } from "../resolution-coding-modal/resolution-coding-modal.component";
import { TreeTable } from "primeng/treetable";
import { ResolutionCodingService } from "src/app/services/resolution-coding.service";
import { AdcRecord } from "src/app/models/adc-record";
import { MessageService } from "primeng/api";
import { DocumentService } from "src/app/services/document.service";
import { AuthService } from "src/app/services/auth.service";
import { environment } from "src/environments/environment";
import { ConfirmationService } from "primeng/api";
import { LinkRecordsModalComponent } from "../link-records-modal/link-records-modal.component";
import { ActivatedRoute } from "@angular/router";
import { PhysicianOrdersComponent } from "src/app/shared/physician-orders/physician-orders/physician-orders.component";
import { UtilityService } from 'src/app/services/utility.service';
import { CommentModalComponent as WmCommentModalComponent } from 'src/app/waste-module/comment-modal/comment-modal.component';
import { formatQuantity } from 'src/app/shared/pipes/format-quantity.pipe';
import { LocationSelectComponent } from 'src/app/shared/location-select/location-select.component'
import { LocationAccessService } from 'src/app/services/location-access.service';
import {
  addUnreconciledDoseResolutions,
  hasPartialUnreconciledDoseResolution,
  removeUnreconciledDoseResolutions
} from '../unreconciled-dose-filter.util';
import { EMPTY, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';
import { cloneFilterState, DataFilterService, FilterState } from 'src/app/services/data-filter.service';
import { PrintAuthUrlService } from 'src/app/services/print-auth-url.service';

interface AddTransactionDraft {
  addTransAutoFill: Discrepancy;
  addTransResolutionCoding: any;
  addTransPracticeIssues: any[];
  addComment: string;
  parentRow: any;
  linkedTransaction?: any;
  linkTransactionAllow?: boolean;
}

@Component({
    selector: "app-urc",
    templateUrl: "./urc.component.html",
    styleUrls: ["./urc.component.css"],
    providers: [ ConfirmationService],
    standalone: false
})
export class UrcComponent implements OnInit, OnDestroy, OnChanges {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private varService = inject(VarianceService);
  private resolutionCodingService = inject(ResolutionCodingService);
  private messageService = inject(MessageService);
  private route = inject(ActivatedRoute);
  documentService = inject(DocumentService);
  authService = inject(AuthService);
  confirmationService = inject(ConfirmationService);
  utility = inject(UtilityService);
  private locationAccessService = inject(LocationAccessService);
  private dataFilterService = inject(DataFilterService);
  private printAuthUrlService = inject(PrintAuthUrlService);

  screenWidth: number = window.innerWidth; // Track screen width
  varianceNodes: TreeNode[] = [];
  commentDialog = false;
  wmCommentDialog = false;
  filterDialog = false;
  linkFilterDialog = false;
  showLinkedRecordsModal = false;
  filterSearchVal: any = "";
  selectedRow: any = {};
  allNodes: any;
  filterOptions: any = {};
  filterFixedOptions: any = {};
  currentPage: any = null;
  varDateString!: string;
  physicianOrder = false;
  resCounts: any = {}
  issueCounts: any = []
  addComment!: string;
  addTransResolutionCoding: any;
  addTransPracticeIssues: any = [];
  @Input() deId = false;
  @Input() isAuditor=true;
  @Input() auditRow: any={
    duration: 7,
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user
    ),
    serviceGroup: "All",
    deIdentifyData: true,
    allAdcEhr: false,
    _id: [],
    showMultiAdmins: "false",
    ia: false
  };
  @Input() auditRiskLevel: any=null
  @Output() shareIndvActiv = new EventEmitter();
  @ViewChild("commentModal") commentModal!: CommentModalComponent;
  @ViewChild("variancett") varianceTt!: TreeTable;
  @ViewChild("resolCoding") resolCoding!: ResolutionCodingModalComponent;
  @ViewChild("linkRecordsModal") linkRecordsModal!: LinkRecordsModalComponent;
  @ViewChild('physicianOrdersModal') physicianOrderModal! : PhysicianOrdersComponent;
  @ViewChild('wmCommentModal') wmCommentModal!: WmCommentModalComponent;
  @ViewChild('locationSelectComp') locationSelectComp!: LocationSelectComponent;
  filter: any = {
    duration: 7,
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user
    ),
    serviceGroup: "All",
    deIdentifyData: true,
    allAdcEhr: false,
    _id: [],
    showMultiAdmins: "false",
    ia: false
  };
  private filterState?: FilterState<any>;
  resolutionCoding: any[] = [];
  selectedIds: any[] = [];
  // Ids the user has manually deselected while `masterSelected` (Select-All-across-pages)
  // is active. Kept as a Set so add/delete/has stay O(1) as the user paginates.
  excludedIds = new Set<string>();
  dataLoaded = true;
  totalCount = 0;
  tableDataIsLoading = true;
  isPrintVariance = false;
  skip_record = 0;
  masterSelected = false;
  selectedCount = 0;

  patientData: any = [];
  patientOptions: any[] = [];
  employeeOptions: any[] = [];
  medicationData: any = [];
  locationData: any = [];
  quantityData: any = [];
  UOMData: any = [];
  transactionData: any = [];
  linkedTansaction: any = [];
  date: Date | undefined;
  addTransAutoFill = new Discrepancy();
  addTransDrafts: Record<string, AddTransactionDraft> = {};
  activeAddTransParentId: string | null = null;
  showLinkTransactions = false;
  @Input() lookbackPeriod!: number;
  @Input() quickTimeOptions: SelectItem[] = [];
  @Output() lookbackPeriodChange = new EventEmitter<number>();
  @Output() filterValue = new EventEmitter();
  @Output() dateValue = new EventEmitter();
  filterSubmitted=false;
  maapkey: any;
  uniqueKey2: any;
  linkTransactionAllow = false;
  locationSelectFilter: any = {region:[], campus:[] , facility:[] , changeValue: true};
  @Input() include_csn!: boolean;
  @Input() active = true;
  footprint: string = environment.footprint;
  locationInitialized = false;
  searchDialog = false;
  isCsnLoading = false;
  private dataStale = false;
  private showUnreconciledDosesOnly = false;
  private readonly destroy$ = new Subject<void>();
  private readonly filterOptionsCancel$ = new Subject<void>();
  private activityOptionDateRange: { duration: number; startDate: string; endDate: string } | null = null;
  private readonly autocompleteSearch$ = new Subject<{ event: { term: string; items: any[] }; key: string; field: string }>();


  ngOnInit(): void {
    this.auditRow = cloneFilterState(this.auditRow || {});
    if(this.auditRow.ia){
      this.auditRow.initializing = true
      for(const prop in this.auditRow){
        if(prop === 'employeeId'){
          this.filter.adminId = Array.isArray(this.auditRow[prop])
            ? [...this.auditRow[prop]]
            : [this.auditRow[prop]];
        }
        else if(!['ia','duration','initializing'].includes(prop)){
          this.filter[prop] = [this.auditRow[prop]]
        }
        else{
          this.filter[prop] = this.auditRow[prop]
        }
      }
      // The area selected in Risk Assessment belongs to the location selector.
      // Keeping it as a separate request filter would prevent clearing Area.
      if (this.auditRow.locationGrouping) {
        this.filter.locationGroupingIds = this.locationAccessService.normalizeValues(
          this.auditRow.locationGrouping, 'locationGroup'
        );
        delete this.filter.locationGrouping;
      }
    }
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x=>this.deId = x.deId);

    this.autocompleteSearch$.pipe(
      debounceTime(300),
      switchMap(({ event, key, field }) => {
        if (key === 'adminId' && this.deId) {
          const searchTerm = event.term.toLowerCase();
          const filteredOptions = this.filterOptions[key].filter((option: any) => {
            if (option.label === 'All') return true;
            return option.label.toLowerCase().includes(searchTerm);
          });
          if (filteredOptions.length > 1) {
            this.filterOptions[key] = filteredOptions;
            return EMPTY;
          }
        }
        if (key === 'patientId' && this.deId) {
          const searchTerm = event.term.toLowerCase();
          const filteredOptions = this.filterOptions[key].filter((option: any) => {
            if (option.label === 'All') return true;
            return option.label.toLowerCase().includes(searchTerm);
          });
          if (filteredOptions.length > 1) {
            this.filterOptions[key] = filteredOptions;
            return EMPTY;
          }
        }
        if (['ptid', 'lanID', 'patientId'].includes(field)) {
          return EMPTY;
        }
        return this.varService.searchAutoComplete(field, event.term, this.filter).pipe(
          map(res => ({ res: res as any[], key, field, event })),
          catchError(() => EMPTY)
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(({ res, key, field }) => {
      if (field === 'csn') {
        this.filterOptions[key] = res;
        this.isCsnLoading = false;
      } else if (key === 'adminId' && this.deId) {
        if (res.length > 0) {
          const newDeIdentifiedOptions = res.sort().map((item: any, index: number) => ({
            label: "AdminID" + (index + 1),
            value: item
          }));
          this.filterOptions[key] = [{ label: "All", value: "All" }].concat(newDeIdentifiedOptions);
        } else {
          this.filterOptions[key] = [{ label: "All", value: "All" }];
        }
      } else if (key === 'patientId' && this.deId) {
        if (res.length > 0) {
          const newDeIdentifiedOptions = res.sort().map((item: any, index: number) => ({
            label: "patientId" + (index + 1),
            value: item
          }));
          this.filterOptions[key] = [{ label: "All", value: "All" }].concat(newDeIdentifiedOptions);
        } else {
          this.filterOptions[key] = [{ label: "All", value: "All" }];
        }
      } else if (key === 'adminId' && this.filterDialog) {
        this.filterOptions.adminId = this.buildAdminIdOptions(res);
      } else {
        this.filterOptions[key] = ["All"].concat(res);
      }
    });

    // this.getTreeNodes();
    //this.setFilterOptions();
    this.resolutionCoding =
      this.resolutionCodingService.getRosolutionCodingData("variance");
    this.locationSelectFilter = this.locationAccessService.buildInitialFilters(this.authService.user, {
      footprint: this.footprint,
      changeValue: true
    });
    if (this.auditRow.ia && this.auditRow.locationGrouping) {
      this.locationSelectFilter.locationGroup = this.locationAccessService.sanitizeSelectedValues(
        this.auditRow.locationGrouping,
        this.authService.user,
        'locationGroup'
      );
    }
    this.applyVariancePageBaseFilter(this.filter);
    this.applyVariancePageBaseFilter(this.auditRow);
    this.captureInitialFilter();
  }

  ngOnDestroy(): void {
    this.filterOptionsCancel$.next();
    this.filterOptionsCancel$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  updateScreenWidth(): void {
    this.screenWidth = window.innerWidth; // Update screen width on resize
  }

  OpenAddTransaction(){
    this.updateAddTransPatientOptions();
  }
  openLinkFilterDialog(){
    this.linkFilterDialog = true;
  }

  openFilterModal() {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filter);
    this.filterState = this.dataFilterService.open(this.filterState);
    this.filter = cloneFilterState(this.filterState.draft);
     if (!this.isAuditor) {
      this.filterDialog = !this.filterDialog;
    }
    else if (this.isAuditor && !this.deId){
      this.filterDialog = !this.filterDialog
    }
    this.setFilterOptions(true);
  }

  closeFilterModal() {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.cancel(this.filterState!);
    this.filter = cloneFilterState(this.filterState.applied);
    this.filterDialog = false;
  }

  resetTable() {
    this.varianceTt.reset();
    this.varianceNodes = [...this.varianceNodes];
  }

  private getFilterOptionsRequestFilter(): any {
    const requestFilter = cloneFilterState(this.filter);
    if (requestFilter.ia && !requestFilter.transactionStartDate && !requestFilter.transactionEndDate &&
        this.activityOptionDateRange?.duration === Number(requestFilter.duration)) {
      requestFilter.transactionStartDate = this.activityOptionDateRange.startDate;
      requestFilter.transactionEndDate = this.activityOptionDateRange.endDate;
    }
    return requestFilter;
  }

  setFilterOptions(openDialog = false) {
    this.filterOptionsCancel$.next();
    this.dataLoaded = false;
    const requestFilter = this.getFilterOptionsRequestFilter();
    this.filterOptions = {
      adminId: this.deId ? [{ label: "All", value: "All" }] : this.buildAdminIdOptions([]),
      patientId: [{ label: "All", value: "All" }]
    };

    this.varService
      .fetchDiscrepancyFilterOptions(requestFilter)
      .pipe(takeUntil(this.filterOptionsCancel$), takeUntil(this.destroy$))
      .subscribe((res) => {
        this.filterOptions = { ...res, ...this.filterOptions };
        this.filterOptions.adminType = [{ label: "All", value: "All" }].concat(
          this.filterOptions.adminType.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.practiceIssue = [{ label: "All", value: "All" }].concat(
          this.filterOptions.practiceIssue.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.loc = [{ label: "All", value: "All" }].concat(
          this.filterOptions.loc.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.resolutionCoding = [
          { label: "All", value: "All" },
        ].concat(
          this.filterOptions.resolutionCoding.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
       
        this.filterOptions.medDescription = [
          { label: "All", value: "All" },
        ].concat(
          this.filterOptions.medDescription.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.medGroupName = [
          { label: "All", value: "All" },
        ].concat(
          this.filterOptions.medGroupName.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        // this.filterOptions.csn = [
        //   { label: "All", value: "All" },
        // ].concat(
        //   this.filterOptions.csn.sort().map(function (item) {
        //     return { label: item, value: item };
        //   })
        // );
        this.filterOptions.transactionType = [].concat(
          this.filterOptions.transactionType.sort().map(function(item: any){
            return {label:item, value:item}
          }));
        this.dataLoaded = true;
        
        // Only open dialog if explicitly requested
        if (openDialog && (!this.isAuditor)) {
          this.filterDialog = true;
        }
        else if(openDialog && this.isAuditor && !this.deId){
          this.filterDialog = true
        }
      }, () => {
        this.dataLoaded = true;
        this.messageService.add({ severity: "error", summary: "Error", detail: "Unable to load filter options." });
      });

    this.varService.searchAutoComplete('adminid', "", requestFilter)
      .pipe(takeUntil(this.filterOptionsCancel$), takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (this.deId) {
          const deIdentifiedRes = res.map((item: any, index: number) => ({
            label: "adminID" + (index + 1),
            value: item
          }));
          this.filterOptions.adminId = [{ label: "All", value: "All" }].concat(deIdentifiedRes);
        } else {
          this.filterOptions.adminId = this.buildAdminIdOptions(res);
        }
      }, () => {
        this.messageService.add({ severity: "error", summary: "Error", detail: "Unable to load User ID suggestions." });
      });

    this.varService.searchAutoComplete('patientid', "", requestFilter)
      .pipe(takeUntil(this.filterOptionsCancel$), takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (this.deId) {
          const deIdentifiedRes = res.map((item: any, index: number) => ({
            label: "patientId" + (index + 1),
            value: item
          }));
          this.filterOptions.patientId = [{ label: "All", value: "All" }].concat(deIdentifiedRes);
        } else {
          this.filterOptions.patientId = [{ label: "All", value: "All" }].concat(res);
        }
      }, () => {
        this.messageService.add({ severity: "error", summary: "Error", detail: "Unable to load Patient ID suggestions." });
      });
          this.filterFixedOptions.transType = [
          {label: 'Show All Verified', value: 'Verified'},
          {label: 'Hide If Verified', value: 'Not Verified'}
        ];
        this.filterFixedOptions.riskLevels = [
          {label:"All", value: "tvs"},
          {label:"High", value: "highRisk"},
          {label:"High-Moderate", value: "highModRisk"},
          {label:"Moderate", value: "modRisk"},
          {label:"Low", value: "lowRisk"},
          {label:"Has Practice Issues", value: "practiceIssue"}
        ]
  }

  submitFilter(callLoad = true) {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filter);
    this.filter = cloneFilterState(this.filterState.applied);
    if (this.showUnreconciledDosesOnly && !hasPartialUnreconciledDoseResolution(this.filter)) {
      addUnreconciledDoseResolutions(this.filter);
    }

    if(this.auditRow.ia){
      if (this.filter.bedDev){
      this.auditRow.locationGroupingString = "MULTIPLE"
      this.auditRow.bedDev = this.filter.bedDev
      }
      if (this.filter.ptid){
        this.auditRow['mrnNum'] = this.filter.ptid
      }
      if (this.filter.adminId){
        this.auditRow['employeeId'] = this.filter.adminId
      }
      if (this.filter.description){
        this.auditRow['medDesc'] = this.filter.description
      }
      if(this.filter.medGroupName){
        this.auditRow['medGroup'] = this.filter.medGroupName
      }
      if(this.filter.adminType){
        this.auditRow['adminType'] = this.filter.adminType
      }
      if(this.filter.resCode){
        this.auditRow['resolution'] = this.filter.resCode
      }
      if(this.filter.practiceIssue){
        this.auditRow['practiceIssue'] = this.filter.practiceIssue
      }
      if(this.filter.riskLevel){
        this.auditRiskLevel = this.filter.riskLevel
      }
      if(this.filter.globalSearch){
        this.auditRow['globalSearch'] = this.filter.globalSearch
      }
      if(this.filter.locationGrouping){
        this.auditRow['locationGrouping'] = this.filter.locationGrouping
      }
      if(this.filter.transType){
        this.auditRow['transType'] = this.filter.transType
      }
      if(this.filter.csn){
        this.auditRow['csn'] = this.filter.csn;
      }
    }
    else{
      this.auditRow = cloneFilterState(this.filter)
    }
    if (this.filter.transactionStartDate) {
      this.auditRow.duration = null;
      if (environment.convert_times) {
        this.filter.timeOffset = 0;
        const localStart = new Date(this.filter.transactionStartDate);
        // Remove timezone offset adjustment
        const utcStartIso = localStart.toISOString();
        this.auditRow.transactionStartDate = utcStartIso;
        this.filter.transactionStartDate = utcStartIso;
        const startDateOffset = localStart.getTimezoneOffset();
        this.auditRow.startDateUtcOffset = -(startDateOffset / 60);
        this.filter.timeOffset = -(startDateOffset / 60);
      } else {
        this.auditRow.transactionStartDate = this.filter.transactionStartDate;
        const startDateOffset = new Date(this.filter.transactionStartDate).getTimezoneOffset();
        this.auditRow.startDateUtcOffset = -(startDateOffset / 60);
        this.filter.timeOffset = -(startDateOffset / 60);
      }
    }

    if (this.filter.transactionEndDate) {
      if (environment.convert_times) {
        this.filter.timeOffset = 0;
        const localEnd = new Date(this.filter.transactionEndDate);
        // Remove timezone offset adjustment
        const utcEndIso = localEnd.toISOString();
        this.auditRow.transactionEndDate = utcEndIso;
        this.filter.transactionEndDate = utcEndIso;
      } else {
        this.auditRow.transactionEndDate = this.filter.transactionEndDate;
      }
    }

    if(callLoad){
      this.filterValue.emit(cloneFilterState(this.filter));
      this.filterRecords();
    }
  }

  clearFilter() {
    if (this.isAuditor){
      this.auditRow.bedDev = null
      this.auditRow.duration = 90
      this.auditRow.mrnNum = null
      this.auditRow.employeeId = null
      this.auditRow.medDesc = null
      this.auditRow.medGroup = null
      this.auditRow.userType = null
      this.auditRow.resolution = null
      this.auditRow.riskLevel = null
      this.auditRow.transType = null
      this.auditRow.practiceIssue = null
      this.auditRow.globalSearch = null
    }
  
    const lookbackPeriod = this.filter.duration;
    let regionID = "All";
    let campusID = "All";
    let facilityID = "All";
    let serviceGroup = "All";
    if (this.filter.regionId != undefined) {
      regionID = this.filter.regionId;
    }
    if (this.filter.campusId != undefined) {
      campusID = this.filter.campusId;
    }
    if (this.filter.facilityId != undefined) {
      facilityID = this.filter.facilityId;
    }
    if (this.filter.serviceGroup != undefined) {
      serviceGroup = this.filter.serviceGroup;
    }
    this.filter = {};
    this.filter.duration = lookbackPeriod;
    this.filter.regionId = regionID;
    this.filter.campusId = campusID;
    this.filter.facilityId = facilityID;
    this.filter.serviceGroup = serviceGroup;
    this.filterValue.emit(cloneFilterState(this.filter));
    this.varianceTt.reset();
  }

  async showCommentEdit(rowData: any) {
    this.selectedRow = {
      ...rowData,
      comment: rowData.comment,
      patientName: rowData.patientName,
      medDesc: rowData.medDesc
    };
    if(rowData.source=="Assay" || rowData.source=="Waste Retrieval")
      {
        this.wmCommentDialog = !this.wmCommentDialog
        this.wmCommentModal.getComments(rowData)
      }
    this.commentModal.comment = ''
    this.commentModal.userAction = ''
    this.messageService.clear();
    this.documentService.tab = 1;
    this.commentDialog = !this.commentDialog;
    this.commentModal.getUserMentions()
    this.commentModal.getComments(rowData);
  }

  openLinkedRecordsModal(rowData: any) {
    this.showLinkedRecordsModal = !this.showLinkedRecordsModal;
    this.linkRecordsModal.updateTable(rowData);
  }

  linkedRecordsModalClosed() {
    this.showLinkedRecordsModal = false;
    this.filterRecords()
  }

  submitMessageCompleted($event: any) {
    this.commentDialog = false;
    this.wmCommentDialog = false;
    if (typeof $event !== "boolean") {
      this.messageService.add($event);
    }
    // this.loadChildData(this.child);
    this.filterRecords();
  }

  getTreeNodes() {
    this.varService.getDiscrepancyData().subscribe((resp: any) => {
      this.varianceNodes = resp.map((val: any) => {
        const node = Discrepancy.toTreeNode(Discrepancy.fromJSON(val)) as TreeNode;
        node.children = [];
        /**
         * MV2-282:  removed "Compiled Data" from displaying on the
         * Variance - URC page.
         *
         * if(val["recordType"] != "Pyxis")
         *   node.children.push(self.getSubOption("Compiled Data"))
         */
        node.children.push(this.getSubOption("ADC Data"));
        node.children.push(this.getSubOption("EHR Data"));
        this.dataLoaded = true;
        return node;
      }) as TreeNode[];
      this.allNodes = this.varianceNodes;
      this.setFilterOptions();
    });
  }

  expandNode(event: any) {
    event.node.expanded = !event.node.expanded;
    const node: TreeNode = event.node;
    if (node.parent == null) {
      node.children!.forEach((childNode) => {
        this.loadChildData(childNode);
      });
    }
    if (this.varianceTt.filteredNodes != null)
      this.varianceTt.filteredNodes = [...this.varianceTt.filteredNodes];
    this.varianceNodes = [...this.varianceNodes];
    return;
  }

  loadChildData(node: TreeNode) {
    const env = environment.environment
    const parentData = node.parent!["data"];
    const mrn = parentData["mrnNum"];
    this.maapkey = parentData["maapKey"];
    this.uniqueKey2 = parentData["uniqueKey2"];
    
    if (node.data["label"] == "EHR Data") {
      const maapkey = node.parent!["data"]["maapKey"];
      const uniqueKey2 = node.parent!["data"]["uniqueKey2"];
      if (!("children" in node.children![0])) {
        this.tableDataIsLoading = true;
        this.varService
          .getEhrData(maapkey, uniqueKey2, env, mrn)
          .subscribe({
            next: (res) => {
              let data = [{}];
              if ((res as any)["docs"].length > 0) {
                data = (res as any)["docs"];
              }
              node.children = data.map((val: any) => {
                (val as any)["Discrepancy"] = formatQuantity((val as any)["Discrepancy"]);
                return AdcRecord.toTreeNode(AdcRecord.fromJSON(val)) as TreeNode;
              });
              node.expanded = true;
              this.varianceNodes = [...this.varianceNodes];
              this.tableDataIsLoading = false;
            },
            error: (err) => {
              this.logger.exception(err);
              this.tableDataIsLoading = false;
            }
          });
      }
    } else if (node.data["label"] == "ADC Data") {
      const maapkey = node.parent!["data"]["maapKey"];
      const uniqueKey2 = node.parent!["data"]["uniqueKey2"];
      if (!("children" in node.children![0])) {
        this.tableDataIsLoading = true;
        this.varService
          .getAdcData(maapkey, uniqueKey2, env, mrn)
          .subscribe({
            next: (res) => {
              let data = [{}];
              if ((res as any)["docs"].length > 0) {
                data = (res as any)["docs"];
              }
              node.children = data.map((val: any) => {
                (val as any)["Discrepancy"] = formatQuantity((val as any)["Discrepancy"]);
                return AdcRecord.toTreeNode(AdcRecord.fromJSON(val)) as TreeNode;
              });
              node.expanded = true;
              this.varianceNodes = [...this.varianceNodes];
              this.tableDataIsLoading = false;
            },
            error: (err) => {
              this.logger.exception(err);
              this.tableDataIsLoading = false;
            }
          });
      }
    }
    else if (node.data["label"] == "Add Transaction"){
      const draft = this.initializeAddTransDraft(parentData, true);
      this.updateAutoFill(draft.addTransAutoFill.patientId, 'patientId', parentData["id"])
      this.updateAutoFill(draft.addTransAutoFill.adminId, 'adminId', parentData["id"])
    } 
    
  }

  formatDateCustom(dateStr: string): string {
    if (environment.convert_times) {
      // Assume dateStr is already in local time string format, just reformat for table
      const dateObj = new Date(dateStr);
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const date = dateObj.getDate().toString().padStart(2, '0');
      const fullYear = dateObj.getFullYear();
      const hours = dateObj.getHours().toString().padStart(2, '0');
      const minutes = dateObj.getMinutes().toString().padStart(2, '0');
      // const seconds = dateObj.getSeconds().toString().padStart(2, '0');
      // Format: MM/DD/YYYY | HH:mm
      return `${month}/${date}/${fullYear} | ${hours}:${minutes}`;
    } else {
      // Use UTC formatting as before
      let output = '';
      const dateObj = new Date(dateStr);
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
      output += month + '/';
      const date = (dateObj.getUTCDate()).toString().padStart(2, '0');
      output += date + '/';
      const fullYear = dateObj.getUTCFullYear();
      output += fullYear + ' | ';
      const hours = (dateObj.getUTCHours()).toString().padStart(2, '0');
      output += hours + ':';
      const minutes = (dateObj.getUTCMinutes()).toString().padStart(2, '0');
      output += minutes;
      return output;
    }
  }

  onNodeExpand(event: any) {
    const node: TreeNode = event.node;
    if (node.parent == null) {

      node.children!.forEach((childNode) => {
        this.loadChildData(childNode);
      });
      
      if (this.dataLoaded) this.setAddLinkItemOptions();
    }
  }

  
  setAddLinkItemOptions() {
      this.dataLoaded = false;
      this.varService
      .fetchDiscrepancyFilterOptions(this.filter)
      .subscribe((res) => {
        this.filterOptions = res;
        this.filterOptions.patientId = [];
        this.filterOptions.adminId = [];
        this.varService
          .searchAutoComplete("patientid", "", this.filter)
          .subscribe((res: any) => {
            this.filterOptions.patientId =
              this.filterOptions.patientId.concat(res);
          });
        this.varService
        .searchAutoComplete("adminid", "", this.filter)
        .subscribe((res: any) => {
          this.filterOptions.adminId = this.filterOptions.adminId.concat(res);
        });
        this.filterOptions.loc = [].concat(
          this.filterOptions.loc.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.uom = [].concat(
          this.filterOptions.uom.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.medDescription = [].concat(
          this.filterOptions.medDescription.sort().map(function (item: any) {
            return { label: item, value: item };
          })
        );
        this.filterOptions.transactionType = [].concat(
          this.filterOptions.transactionType.sort().map(function(item: any){
            return {label:item, value:item}
          }));
        this.dataLoaded = true;
      });  
  }
  
  getSubOption(str: any) {
    return {
      data: {
        label: str,
      },
      children: [{}],
    };
  }
  getNodeLevel(node: any) {
    if (node.parent == null) {
      return 1;
    } else if (node.parent.parent == null) {
      return 2;
    } 
    else {
      return 3;
    }
  }

  getResolutionBg(val: any) {
    return this.resolutionCodingService.getReolutionCodingBg(val);
  }

  rowClass(rowtype: any) {
    /**
     * MV2-282:  removed "Compiled Data" from displaying on the
     * URC page.
     *
     * if(rowtype == 'Compiled Data')
     * {
     *   return "row-compiled-data";
     * }else if(rowtype == 'ADC Data')
     */
    if (rowtype == "ADC Data") {
      return "row-adc-data";
    } else if (rowtype == "EHR Data") {
      return "row-ehr-data";
    } else if (rowtype == "Add Transaction") {
      return "row-add-link";
    }
  }

  getChildRowClass(rowtype: any) {
    /**
     * MV2-282:  removed "Compiled Data" from displaying on the
     * URC page.
     *
     * if(rowtype == 'Compiled Data')
     * {
     *   return "detailsrow-compiled-data";
     * }else if(rowtype == 'ADC Data')
     */
    if (rowtype == "ADC Data") {
      return "detailsrow-adc-data";
    } else if (rowtype == "EHR Data") {
      return "detailsrow-ehr-data";
    } else if (rowtype == "Add Transaction") {
      return "detailsrow-add-link";
    }
  }

  changeServiceGroup(serviceGroup: any) {
    this.filter.serviceGroup = serviceGroup;
    this.filterRecords();
  }

  submitGlobalFilter() {
    this.auditRow['globalSearch'] = this.filter.globalSearch
    this.filterRecords();
  }

  loadRecordsLazy(event: any) {
    if (!this.locationInitialized) {
      return;
    }
    
    if (event.sortField) {
      this.filter.$sortField = event.sortField;
      this.filter.$sortOrder = event.sortOrder;
      this.auditRow.$sortField = event.sortField;
      this.auditRow.$sortOrder = event.sortOrder;
    }

    this.tableDataIsLoading = true;
    this.skip_record = event["first"];
    this.currentPage = event["first"]
    if (!this.auditRow['ia'] && !this.auditRow['getGraph']){
      this.auditRow = cloneFilterState(this.filter)
    }
    if (this.auditRow['ia']){
      if(this.auditRow.initializing){
        this.auditRow.initializing = false
      }
      else{
        this.submitFilter(false)
      }
    }
    this.tableDataIsLoading = true;
    const activityFilter = this.getActivityFilter();
    this.varService
      .getActivityDiscrepancyData(this.skip_record, activityFilter)
      .subscribe((resp) => {
        this.tableDataIsLoading = true;
        const responseDate = (resp as any)['date'];
        if (this.auditRow.ia && responseDate?.startDate && responseDate?.endDate) {
          this.activityOptionDateRange = {
            duration: Number(this.filter.duration),
            startDate: new Date(responseDate.startDate).toISOString(),
            endDate: new Date(new Date(responseDate.endDate).getTime() + 1).toISOString()
          };
        }
        this.resCounts = (resp as any)['resCounts']
        if((resp as any)['issueCounts'][0])
        this.issueCounts = (resp as any)['issueCounts'][0]['issues']
        if (this.skip_record == 0)
          this.totalCount = (resp as any)["count"];
        this.allNodes = (resp as any)['docs']
        this.addTransDrafts = {};
        this.activeAddTransParentId = null;
        // Map to nodes and find max varDate (converted to local time)
        let maxDate: Date | null = null;
        const duration = Number(this.filter.duration) || 7;
        this.varianceNodes = (resp as any)['docs']
          .filter((val: any) => val["source"] !== "Assay" && val["source"] !== "Waste Retrieval")
          .map((val: any) => {
            const discrepancy = Discrepancy.fromJSON(val);
            const node = Discrepancy.toTreeNode(discrepancy);
            // Find max local varDate
            if (discrepancy.varDate instanceof Date && !isNaN(discrepancy.varDate.getTime())) {
              // Convert to local time
              const localDate = new Date(discrepancy.varDate.getTime() - discrepancy.varDate.getTimezoneOffset() * 60000);
              if (!maxDate || localDate > maxDate) {
                maxDate = localDate;
              }
            }
            return node;
          }) as TreeNode[];
        // Emit date range using filter if defined, else use local max date
        if (this.filter.transactionStartDate && this.filter.transactionEndDate) {
          // Use filter dates, convert to local time
          const transactionStartDate = new Date(this.filter.transactionStartDate);
          const transactionEndDate = new Date(this.filter.transactionEndDate);
          const localStart = new Date(transactionStartDate.getTime() - transactionStartDate.getTimezoneOffset() * 60000);
          const localEnd = new Date(transactionEndDate.getTime() - transactionEndDate.getTimezoneOffset() * 60000);
          this.dateValue.emit({
            startDate: localStart.toISOString(),
            endDate: localEnd.toISOString()
          });
        } else if (maxDate) {
          const endDate = new Date(maxDate);
          const startDate = new Date(endDate);
          startDate.setDate(endDate.getDate() - duration);
          this.dateValue.emit({
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
          });
        } else if (responseDate?.startDate && responseDate?.endDate) {
          this.dateValue.emit(responseDate);
        } else {
          this.dateValue.emit(null);
        }
        this.setInitialSelectionState();
        this.tableDataIsLoading = false;
      }, (err) => {
        this.activityOptionDateRange = null;
        this.logger.exception(err);
        this.resCounts = {};
        this.issueCounts = [];
        this.totalCount = 0;
        this.allNodes = [];
        this.varianceNodes = [];
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Unable to load Individual Activity."
        });
        this.tableDataIsLoading = false;
      });   
    // }
  }

  filterRecords() {
    let first = 0;
    if (this.varianceTt && typeof this.varianceTt.first === 'number') {
      first = this.varianceTt.first;
    } else if (this.currentPage != null) {
      first = this.currentPage;
    }

    const obj = { first };
    // Any filter change invalidates the current global selection because the
    // selected ids may no longer belong to the result set.
    this.clearSelection();
    this.loadRecordsLazy(obj);
    //this.varianceTt.reset();
  }

  updateLookbackPeriod(lookbackPeriod: any) {
    this.filter.duration = lookbackPeriod;
    this.auditRow.duration = lookbackPeriod
    if (this.active && this.locationInitialized) {
      this.filterRecords();
    } else {
      this.dataStale = true;
    }
  }

  onLocationChanged(event: any) {
    this.filterDialog = false;
    this.locationAccessService.applyAuthorizedFilters(this.filter, event, this.authService.user);
    this.auditRow.regionId = event.region
    this.auditRow.campusId = event.campus
    this.auditRow.facilityId = this.filter.facilityId
    this.auditRow.locationGroupingIds = this.filter.locationGroupingIds
    this.filterRecords();
  }

  onServiceGrpChanged(event: any) {
    this.filter.serviceGroup = event.serviceGroup;
    this.auditRow.serviceGroup = event.serviceGroup
    this.filterRecords();
  }

  searchWithAutoComplete(event: any, key: any, field: any) {
    this.autocompleteSearch$.next({ event, key, field });
  }

  private buildAdminIdOptions(values: string[]): { label: string; value: string }[] {
    const selected = Array.isArray(this.filter.adminId) ? this.filter.adminId : [this.filter.adminId];
    const ids = ['All', ...selected, ...values].filter(
      (value): value is string => typeof value === 'string' && value.length > 0 &&
        (!this.filter.ia || !/^\*+SYSTEM\*+$/i.test(value.trim().replace(/&#(?:x4d|77);/gi, 'M')))
    );
    return [...new Set(ids)].map((value) => ({ label: value, value }));
  }

  onCsnSearch(event: any): void {
    if (event.term && event.term.length > 0) {
      this.isCsnLoading = true;
      this.autocompleteSearch$.next({ event, key: 'csn', field: 'csn' });
    }
  }

  onCsnSelected(): void {
    this.isCsnLoading = false; // Stop loading once a CSN is selected
  }

  ngSelectSearch(searchTerm: string, eachObject: any) {
    const invalid = /[[\]°"§%() {}=\\?´`'#<>|,;.:+_-\s]+/g;
    const replacedKey = searchTerm.replace(invalid, "");
    const newRegEx = new RegExp(replacedKey, "gi");
    try {
      const purgedName = eachObject.value.replace(invalid, "");
      if (newRegEx.test(purgedName)) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  resetCode(key: any) {
    delete this.filter[key];
  }

  onHideModal() {
    this.commentModal.taggedUsers = []
    this.commentModal.stopPolling();
  }

  onShowModal() {
    this.commentModal.taggedUsers = []
    this.commentModal.startPolling();
  }

  removeVarianceFilters(updatedFilter: any, days: number) {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, cloneFilterState(updatedFilter || {}));
    this.filter = cloneFilterState(this.filterState.applied);
    
    // Ensure duration is set if no dates are specified
    if (!this.filter.duration && (!this.filter.transactionEndDate && !this.filter.transactionStartDate)) {
      this.filter.duration = days;
    }

    this.filterValue.emit(cloneFilterState(this.filter));

    // Reset table and immediately trigger data refresh without opening filter modal
    this.varianceTt.reset();
    this.currentPage = 0; // Reset to first page when filter changes
    this.filterDialog = false; // Ensure filter dialog stays closed
    this.filterRecords();
  }

  openVarianceFilter(filter: any) {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, cloneFilterState(filter || {}));
    this.filter = cloneFilterState(this.filterState.applied);
    this.openFilterModal();
  }

  refreshToInitialState(): void {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.refresh(this.filterState!);
    this.filter = cloneFilterState(this.filterState.applied);
    this.auditRow = cloneFilterState(this.filter);
    this.filterDialog = false;
    this.searchDialog = false;
    this.currentPage = 0;
    this.varianceTt?.reset();
    this.filterValue.emit(cloneFilterState(this.filter));
    this.filterRecords();
  }

  private captureInitialFilter(): void {
    this.filterState = this.dataFilterService.create(this.filter);
    this.filter = cloneFilterState(this.filterState.applied);
  }

  private ensureFilterState(): void {
    if (!this.filterState) this.captureInitialFilter();
  }

  printVariance() {
    if (!this.transactionSelections()) {
      alert('You must first select a transaction before printing.');
      return false;  
      }
    else{
      this.isPrintVariance = true;
    }
  }
  
  transactionSelections() {
      return this.getSelectedCount() > 0;
    }

  /**
   * Effective selection count. In "select-all across pages" mode it is the
   * server-side totalCount minus any rows the user has individually deselected.
   * In individual-selection mode it is the length of selectedIds. This is what
   * the print guard and the UI counter should reflect.
   */
  private getSelectedCount(): number {
    if (this.masterSelected) {
      return Math.max(0, (this.totalCount || 0) - this.excludedIds.size);
    }
    return this.selectedIds.length;
  }


  tryClearWhitespaceFromGlobalSearch(params: any) {
    if (params.globalSearch) {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  generateQueryStringFromObject(params: any) {
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
  }

  submitPrintFilter() {
    // include user's timezone info so backend can respect local timezone
    const timeZoneName = (typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone || '' : '';
    const timeOffset = getLocalTimeOffset(); // hours offset (consistent with other code)
    const tzParam = `&timeZoneName=${encodeURIComponent(timeZoneName)}&timeOffset=${encodeURIComponent(timeOffset)}`;
    const commonParams =
      "&allAdcEhr=" + this.filter.allAdcEhr +
      "&deIdentifyData=" + this.filter.deIdentifyData +
      '&$limit=2000' +
      tzParam;

    if (this.masterSelected) {
      // Select-all across pages: resolve every matching id via the filter, drop
      // anything the user manually deselected, hand the resulting list to the
      // backend via a short-lived token, then open the print window.
      this.tableDataIsLoading = true;
      const activityFilter = this.getActivityFilter();
      this.varService
        .getActivityDiscrepancyIds(activityFilter)
        .subscribe({
          next: (resp: any) => {
            const docs = (resp && resp.docs) || [];
            const allIds: string[] = docs
              .map((d: any) => (d && (d._id || d.id) ? String(d._id || d.id) : null))
              .filter((id: string | null): id is string => !!id);
            const ids = allIds.filter(id => !this.excludedIds.has(id));

            if (ids.length === 0) {
              this.tableDataIsLoading = false;
              alert('No transactions match the current filters.');
              return;
            }

            this.varService.requestVariancePrintToken(ids).subscribe({
              next: (tokenResp) => {
                this.tableDataIsLoading = false;
                const token = tokenResp && tokenResp.token;
                if (!token) {
                  alert('Unable to prepare print. Please retry.');
                  return;
                }
                const url =
                  environment.apiUrl +
                  'variancePrinting?token=' + encodeURIComponent(token) +
                  commonParams;
                this.printAuthUrlService.openAuthenticatedPrint(
                  url,
                  'location=yes,height=1847,width=1002'
                );
                this.clearSelection();
              },
              error: (err) => {
                this.tableDataIsLoading = false;
                this.logger.exception(err, { operation: 'requestVariancePrintToken' });
                alert('Unable to prepare print. Please retry.');
              }
            });
          },
          error: (err) => {
            this.tableDataIsLoading = false;
            this.logger.exception(err, { operation: 'getActivityDiscrepancyIds' });
            alert('Unable to prepare print. Please retry.');
          }
        });
      return;
    }

    // Individual-row selection: existing GET flow.
    if (!this.selectedIds || this.selectedIds.length === 0) {
      // Belt-and-suspenders: an empty ids= parameter would cause the backend
      // to skip the _id filter entirely and print the whole collection.
      alert('You must first select a transaction before printing.');
      return;
    }
    this.filter["_id"] = this.selectedIds;
    const url =
      environment.apiUrl +
      "variancePrinting?ids=" +
      this.selectedIds +
      commonParams;
    this.printAuthUrlService.openAuthenticatedPrint(
      url,
      'location=yes,height=1847,width=1002'
    );
    this.clearSelection();
   }

  isPrint(e: any, rowData: any) {
    const id = rowData?.id;
    if (id == null) {
      return;
    }
    if (e) {
      rowData.isSelected = true;
      if (this.masterSelected) {
        // Re-including a row that was previously excluded in select-all mode.
        this.excludedIds.delete(String(id));
      } else if (!this.selectedIds.includes(id)) {
        this.selectedIds.push(id);
      }
    } else {
      rowData.isSelected = false;
      if (this.masterSelected) {
        // In select-all mode, individual uncheck adds to the exclusion set;
        // the header checkbox stays checked to preserve the "select all" intent.
        this.excludedIds.add(String(id));
      } else {
        const index: number = this.selectedIds.indexOf(id);
        if (index !== -1) {
          this.selectedIds.splice(index, 1);
        }
      }
    }
    this.selectedCount = this.getSelectedCount();
  }

  checkUncheckAll(e: { checked: boolean } | any) {
    // PrimeNG's p-checkbox emits (onChange) with a { checked: boolean } payload
    // after [(ngModel)] has been updated. That is far more reliable than
    // reading e.target.checked from a raw DOM click, which is undefined when
    // the click lands on the box div/icon rather than the hidden native input.
    const checked = !!(e && e.checked);
    if (checked) {
      this.masterSelected = true;
      this.excludedIds.clear();
      this.selectedIds = [];
      for (const varianceNode of this.varianceNodes) {
        varianceNode["data"].isSelected = true;
      }
    } else {
      this.masterSelected = false;
      this.excludedIds.clear();
      this.selectedIds = [];
      for (const varianceNode of this.varianceNodes) {
        varianceNode["data"].isSelected = false;
      }
    }
    this.selectedCount = this.getSelectedCount();
  }

  deSelectChecks(){
    this.checkUncheckAll({ checked: false })
  }

  /**
   * Fully reset selection state. Called when filters change or when a print
   * request is submitted; keeps the UI in sync with the fact that the ids the
   * user had selected may no longer belong to the current filter result set.
   */
  private clearSelection(): void {
    this.masterSelected = false;
    this.excludedIds.clear();
    this.selectedIds = [];
    this.selectedCount = 0;
    if (this.filter) {
      this.filter._id = [];
    }
    for (const varianceNode of this.varianceNodes) {
      if (varianceNode && varianceNode["data"]) {
        varianceNode["data"].isSelected = false;
      }
    }
  }

  setInitialSelectionState() {
    // Re-apply the current selection intent to whichever page just loaded.
    // In select-all mode, every row is selected except those in excludedIds.
    // In individual mode, only ids the user explicitly picked stay checked.
    if (this.masterSelected) {
      for (const varianceNode of this.varianceNodes) {
        const id = varianceNode?.["data"]?.["id"];
        if (id == null) continue;
        varianceNode["data"].isSelected = !this.excludedIds.has(String(id));
      }
    } else {
      for (const varianceNode of this.varianceNodes) {
        const id = varianceNode?.["data"]?.["id"];
        if (id == null) continue;
        varianceNode["data"].isSelected = this.selectedIds.indexOf(id) !== -1;
      }
    }
    this.selectedCount = this.getSelectedCount();
  }
  updateUnreconciledOnly(showUnreconciledDosesOnly: boolean, refreshRecords = true, syncFilter = true) {
    this.showUnreconciledDosesOnly = showUnreconciledDosesOnly === true;
    if (syncFilter) {
      if (this.showUnreconciledDosesOnly) {
        addUnreconciledDoseResolutions(this.filter);
      } else {
        removeUnreconciledDoseResolutions(this.filter);
      }
    }
    if (refreshRecords) {
      this.filterRecords();
    }
  }

  private applyVariancePageBaseFilter(filter: any) {
    if (!this.isAuditor && filter) {
      filter.showMultiAdmins = "true";
    }
  }

  private getActivityFilter() {
    const activityFilter = { ...this.filter };
    this.applyVariancePageBaseFilter(activityFilter);

    if (this.showUnreconciledDosesOnly) {
      addUnreconciledDoseResolutions(activityFilter);
    }

    return activityFilter;
  }

  clearTableSearch() {
    this.filter.globalSearch = "";
    this.auditRow['globalSearch'] = null
  }

  linkSelectedRecords() {
    const selectedIds: any[] = [];
    for (const varianceNode of this.varianceNodes) {
      if (varianceNode["data"].isSelected) {
        selectedIds.push(varianceNode["data"].id);
      }
    }
    if (selectedIds.length == 0) {
      this.confirmationService.confirm({
        header: "Info",
        message: "no records selected to link.",
        acceptLabel: "Ok",
        rejectVisible: false,
        accept: () => {
          //Actual logic to perform a confirmation
        },
      });
    } else {
      this.confirmationService.confirm({
        header: "Confirm",
        message:
          selectedIds.length.toString() +
          " records will be linked, continue ? ",
        accept: () => {
          this.varService
            .submitLinkRecords(selectedIds)
            .subscribe((res: any) => {
              res.forEach((id: any) => {
                const varRecord = this.varianceNodes.filter(
                  (record) => record.data.id == id
                )[0];
                varRecord.data.isLinked = true;
                varRecord.data.isSelected = false;
              });
            });
        },
      });
    }
  }

  linkModalRecordsRemoved(res: any){
    res.forEach((id: any) => {
      const varRecord = this.varianceNodes.filter(
        (record) => record.data.id == id
      )[0];
      varRecord.data.isLinked = false;
    });
  }

  updateEndDate(){
    this.filter.transactionEndDate = this.filter.transactionStartDate
  }
  onMedGroupChanges(){
    this.varService.fetchDiscrepancyFilterOptions(this.filter).subscribe(res=>{
      this.filterOptions.medDescription = (res as any)['medDescription'];
    });
  }


  addPatientDataEntry(rec: any) {
    const data = {};
    (data as any)["patientName"] = rec["patientName"];
    this.patientData[rec["patientId"]] = data;

  }

  getAddTransParentData(rowNode: any) {
    if (rowNode?.parent?.data?.label == "Add Transaction") {
      return rowNode.parent.parent?.data;
    }

    if (rowNode?.data?.label == "Add Transaction") {
      return rowNode.parent?.data;
    }

    return rowNode?.parent?.data || rowNode?.data;
  }

  getAddTransDraft(rowNode: any): AddTransactionDraft | null {
    const parentData = this.getAddTransParentData(rowNode);
    if (!parentData) {
      return null;
    }

    return this.initializeAddTransDraft(parentData);
  }

  getAddTransDraftKey(parentData: any): string {
    return String(parentData?.id || parentData?._id || parentData?.uniqueKey2 || "");
  }

  initializeAddTransDraft(parentData: any, reset = false): AddTransactionDraft {
    const parentId = this.getAddTransDraftKey(parentData);
    if (!reset && this.addTransDrafts[parentId]) {
      return this.addTransDrafts[parentId];
    }

    const addTransAutoFill = new Discrepancy();
    addTransAutoFill.medId = parentData["medId"];
    addTransAutoFill.patientId = parentData["mrnNum"];
    addTransAutoFill.patientName = parentData["patientName"];
    addTransAutoFill.adminId = parentData["adminId"];
    addTransAutoFill.employeeName = parentData["employeeName"];
    addTransAutoFill.adminGroup = parentData["adminGroup"];
    addTransAutoFill.serviceGroup = parentData["serviceGroup"];
    addTransAutoFill.loc = parentData["loc"];
    addTransAutoFill.medDesc = parentData["medDesc"];
    addTransAutoFill.uom = parentData["uom"];
    addTransAutoFill.id = parentData["id"];
    addTransAutoFill.resolutionCoding = parentData["resolutionCoding"];
    addTransAutoFill.practiceIssue = (parentData["practiceIssue"] || []).map((issue: any) => { return { label: issue, value: issue } });
    addTransAutoFill.verified = parentData["transType"];
    addTransAutoFill.varDateString = null;
    addTransAutoFill["maapKey"] = parentData["maapKey"];
    addTransAutoFill["uniqueKey2"] = parentData["uniqueKey2"];

    this.addTransDrafts[parentId] = {
      addTransAutoFill: addTransAutoFill,
      addTransResolutionCoding: { label: addTransAutoFill.resolutionCoding, value: addTransAutoFill.resolutionCoding },
      addTransPracticeIssues: addTransAutoFill.practiceIssue,
      addComment: "",
      parentRow: parentData,
      linkedTransaction: null,
      linkTransactionAllow: false
    };

    return this.addTransDrafts[parentId];
  }

  getActiveAddTransDraft(): AddTransactionDraft | null {
    if (!this.activeAddTransParentId) {
      return null;
    }

    return this.addTransDrafts[this.activeAddTransParentId] || null;
  }

  updateAddTransPatientOptions(){
    this.patientData = [];
    this.patientOptions = []
    this.varService.fetchAddTransactionFilterOptions(this.filter).subscribe(res => {
      this.filterOptions = Object.assign(this.filterOptions, res)
      this.filterOptions.patientInformation.forEach((item: any) => this.addPatientDataEntry(item));
    })

  }
  updateAutoFill(item: any, val: any, parentId: any = null) {
    const draft = parentId ? this.addTransDrafts[String(parentId)] : null;
    const addTransAutoFill = draft ? draft.addTransAutoFill : this.addTransAutoFill;
    const filter = Object.assign({}, this.filter);
    if(val == 'patientId' || val == 'adminId'){
    if(val == 'patientId'){filter.ptid = item;}
    if(val == 'adminId'){
      filter.adminId = item;
    }
    this.varService
    .getDiscrepancyPagedData(0, 10, filter)
    .subscribe(
      (res) => {
        if((res as any)['docs'][0]) {
        if(val == 'patientId' && (res as any)['docs'][0].patientName.length)
        addTransAutoFill.patientName = (res as any)['docs'][0].patientName
        if(val == 'adminId' && (res as any)['docs'][0].employeeName)
        addTransAutoFill.employeeName = (res as any)['docs'][0].employeeName
      if(val == 'adminId' && (res as any)['docs'][0].adminGroup)
        addTransAutoFill.adminGroup = (res as any)['docs'][0].adminGroup
        addTransAutoFill.serviceGroup = (res as any)['docs'][0].serviceGroup
        }
      })
    }
    else if(val == 'medDesc'){
      // Intentionally no-op: med description selection does not trigger autofill mapping.
    }
    else {
      (addTransAutoFill as any)[val] = item.value;
    }
  }

  showLinkDialog(parentId: any = null){
      this.activeAddTransParentId = parentId ? String(parentId) : this.activeAddTransParentId;
      this.showLinkTransactions = true
  }
  submitAddOn(rowNode: any = null){
    const parentData = rowNode ? this.getAddTransParentData(rowNode) : null;
    const parentId = parentData ? this.getAddTransDraftKey(parentData) : this.activeAddTransParentId;
    const draft = parentId ? this.addTransDrafts[parentId] : null;
    const addTransAutoFill = draft ? draft.addTransAutoFill : this.addTransAutoFill;

    if (!addTransAutoFill.varDateString || !addTransAutoFill.amount || !addTransAutoFill.transType) {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields.",
      });
      return;
    }
    this.tableDataIsLoading = true;
    addTransAutoFill["maapKey"] = draft?.parentRow?.maapKey || parentData?.maapKey || this.maapkey;
    addTransAutoFill["uniqueKey2"] = draft?.parentRow?.uniqueKey2 || parentData?.uniqueKey2 || this.uniqueKey2;
    if(addTransAutoFill["transType"]["value"] == "Chart") {
      (addTransAutoFill as any)["recordType"] = 'EHR';
    }
    this.commentModal.selectedRow = draft?.parentRow || parentData || this.commentModal.selectedRow;
    this.commentModal.userAction = "Transaction Added - " + addTransAutoFill['transType']["value"] + " for " + addTransAutoFill['medDesc'];
    this.commentModal.resCoding = addTransAutoFill.resolutionCoding;
    this.commentModal.comment = draft ? draft.addComment : this.addComment;
    this.commentModal.transType = addTransAutoFill.verified;
    this.commentModal.selectedRow.lanId = addTransAutoFill.adminId;
    this.commentModal.practiceIssue = ((draft ? draft.addTransPracticeIssues : this.addTransPracticeIssues) || []).map((issue: any)=>{return issue['value']});
    addTransAutoFill['transType']["value"] = "*" + addTransAutoFill['transType']["value"] + "*";
    addTransAutoFill.varDateString = new Date(addTransAutoFill.varDateString as any).toISOString();
    if(!(draft ? draft.linkTransactionAllow : this.linkTransactionAllow)) {
      this.varService
      .addRecords(addTransAutoFill)
      .subscribe(() => {
        this.varianceTt.reset();
        this.commentModal.submit();
        this.tableDataIsLoading = false;
      });
    } else {
      this.varService
      .linkRecords(draft?.linkedTransaction || this.linkedTansaction)
      .subscribe(() => {
        this.varianceTt.reset();
        this.deleteTransaction((draft?.linkedTransaction || this.linkedTansaction)["_id"], parentId);
        this.showLinkTransactions = false;
      });
    }
  }

  selectedDataValue($event: any) {
    const draft = this.getActiveAddTransDraft();
    if (draft) {
      draft.linkedTransaction = $event;
    }
    this.linkedTansaction = $event;
  }

  linkTransaction() {
    const draft = this.getActiveAddTransDraft();
    const linkedTransaction = draft?.linkedTransaction || this.linkedTansaction;
    if (!linkedTransaction) {
      return;
    }

    linkedTransaction["maapKey"] = draft?.parentRow?.maapKey || this.maapkey;
    linkedTransaction["uniqueKey2"] = draft?.parentRow?.uniqueKey2 || this.uniqueKey2;
    this.tableDataIsLoading = true;
    this.tableDataIsLoading = false;
    this.showLinkTransactions = false;
    if (draft) {
      draft.addTransAutoFill.patientId = linkedTransaction.mrnNum;
      draft.addTransAutoFill.adminId = linkedTransaction.lanID;
      draft.addTransAutoFill = linkedTransaction;
      draft.addTransAutoFill.loc = linkedTransaction.loc;
      draft.linkTransactionAllow = true;
    } else {
      this.addTransAutoFill.patientId = linkedTransaction.mrnNum;
      this.addTransAutoFill.adminId = linkedTransaction.lanID;
      this.addTransAutoFill = linkedTransaction;
      this.addTransAutoFill.loc = linkedTransaction.loc;
      this.linkTransactionAllow = true;
    }
  }


  deleteTransaction(id: any, parentId: any = null) {
    this.varService
    .deleteRecords(id)
    .subscribe(() => {
      if (parentId && this.addTransDrafts[String(parentId)]) {
        this.addTransDrafts[String(parentId)].addTransAutoFill = new Discrepancy();
      } else {
        this.addTransAutoFill = new Discrepancy();
      }
    });
  }

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }
  openOrders(row: any){
    this.physicianOrderModal.loadOrderData(row);
    this.physicianOrder = true
  }
  shareVariances(){
    this.shareIndvActiv.emit(this.varianceNodes)
  }
  getItemsToBeShared(){
    return this.varianceNodes.filter(node => node.data["isSelected"]== true)
  }

  addTransResolutionUpdate(parentId: any = null){
    const draft = parentId ? this.addTransDrafts[String(parentId)] : null;
    if (draft) {
      draft.addTransAutoFill.resolutionCoding = draft.addTransResolutionCoding['value'];
      return;
    }

    this.addTransAutoFill.resolutionCoding = this.addTransResolutionCoding['value']
  }

  getChildColspan(){
    if (this.include_csn)
      return "15"
    else
      return "13"
  }

  onLocationSelectInitialized(initialFilter: any): void {
    if (this.locationInitialized) {
      return;
    }

    this.locationAccessService.applyAuthorizedFilters(this.filter, initialFilter, this.authService.user);
    this.captureInitialFilter();

    // Mark as initialized and trigger single data load
    this.locationInitialized = true;
    this.filterValue.emit(cloneFilterState(this.filter));
    if (this.active) {
      this.loadRecordsLazy({first: 0});
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['active'] && changes['active'].currentValue && !changes['active'].firstChange) {
      if (this.dataStale && this.locationInitialized) {
        this.dataStale = false;
        this.filterRecords();
      } else if (this.locationInitialized && !this.varianceNodes.length) {
        this.loadRecordsLazy({first: 0});
      }
    }
  }

  getFilterTooltip(){
    if (this.deId && this.isAuditor){
      return "This feature is disabled in de-identified mode"
    }
    else
      return "Advanced Filter"
  }

  showSearchDialog(){
    this.searchDialog = true;
  }

  formatName(name: string): string {
    if (!name) return name;
    let formattedName = name.replace(/,\s*/g, ', ');
    
    // Capitalize first letter of each word
    formattedName = formattedName.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    
    return formattedName;
  }
}
